module.exports = "https://trybtryb-legacy.web.app/img/acast.9440e050.svg";